import { BASE_EXCLUDED_SECTIONS } from "./constants";

export function buildExcludedSections(survey) {
  const sections = new Set(BASE_EXCLUDED_SECTIONS);

  applyBurialOrCremationRules(sections, survey);
  applyBrandRules(sections, survey);
  applyDealStageRules(sections, survey);

  return sections;
}

function applyBurialOrCremationRules(sections, survey) {
  const burialOrCremation = survey.getValue("burial_or_cremation");
  if (burialOrCremation === "burial") {
    sections.add("Return of Ashes");
  } else if (burialOrCremation === "cremation") {
    sections.add("Burial Details");
  }
}

function applyBrandRules(sections, survey) {
  if (survey.getValue("brand") === "light") {
    sections.add("Estate Administration");
  }
}

function applyDealStageRules(sections, survey) {
  if (survey.getValue("dashboard_stage") === "deal") {
    sections.add("About the Death");
  }
}
